import isEqual from 'lodash/isEqual';

const arePropsEqual = ({ item: prevItem, options: prevOptions }, { item: nextItem, options: nextOptions }) =>
  prevItem.id === nextItem.id || isEqual(prevOptions, nextOptions);

export { arePropsEqual };
